import {
  CROSS_REGION_PICK_FEE_PRODUCT_NUMBER,
  DEFAULT_DOCUMENT_FEE,
  DOCUMENT_FEE_PRODUCT_NUMBER_300,
  DOCUMENT_FEE_PRODUCT_NUMBER_400,
  DOCUMENT_FEE_PRODUCT_NUMBER_590,
  HANDLING_FEE_PRODUCT_NUMBER,
  LICENSE_SERVICE_FEE_PRODUCT_NUMBER,
  LOCAL_REGION_PICK_FEE_PRODUCT_NUMBER,
  SPECIAL_PICK_FEE_PRODUCT_NUMBER,
} from "modules/payment"

/**
 * 最新 => "590", "GRS6B2-00069"
 * 2025/3/31 前 => "400", "GRS6B2-00060"
 * 2019/12/25 前 => "300", "GRS6B2-00026"
 */
const documentFeeMap = {
  [DOCUMENT_FEE_PRODUCT_NUMBER_590]: 590,
  [DOCUMENT_FEE_PRODUCT_NUMBER_400]: 400,
  [DOCUMENT_FEE_PRODUCT_NUMBER_300]: 300,
}

/**
 * 取得文件費, 未來如果又要調整價格，請在documentFeeMap新增一筆資料
 * @param {Array} productList - it is including scooter, combo, document fee, handling fee, etc...
 * @return {Integer} price
 */
export const getDocumentFee = (productList) => {
  if (!productList) {
    return null
  }

  let documentFee = DEFAULT_DOCUMENT_FEE

  const documentSkuList = Object.keys(documentFeeMap)
  for (let sku of documentSkuList) {
    const documentFeeObj = productList.find((obj) => obj.ProductNo === sku)
    if (documentFeeObj) {
      documentFee = documentFeeObj.Price || documentFeeMap[sku]
      break
    }
  }

  return documentFee
}

export const getPickNumberServiceFee = (productList) => {
  if (!productList) {
    return null
  }
  let pickNumberServiceFee = 0
  const pickNumberServiceFeeObj = productList.find((obj) =>
    [
      LOCAL_REGION_PICK_FEE_PRODUCT_NUMBER,
      CROSS_REGION_PICK_FEE_PRODUCT_NUMBER,
      SPECIAL_PICK_FEE_PRODUCT_NUMBER,
    ].includes(obj.ProductNo),
  )
  if (pickNumberServiceFeeObj) {
    pickNumberServiceFee = pickNumberServiceFeeObj.Price
  }
  return pickNumberServiceFee
}

export const getLicenseServiceFee = (productList) => {
  if (!productList) {
    return null
  }
  let licenseServiceFee = 0
  const licenseServiceFeeObj = productList.find((obj) => obj.ProductNo === LICENSE_SERVICE_FEE_PRODUCT_NUMBER)
  if (licenseServiceFeeObj) {
    licenseServiceFee = licenseServiceFeeObj.Price
  }
  return licenseServiceFee
}

export const filterProductByType = (productList, type) => {
  if (!productList) {
    return []
  }
  if (Array.isArray(type)) {
    return productList.filter((obj) => type.includes(obj.Type))
  } else {
    return productList.filter((obj) => obj.Type === type)
  }
}

export const getHandlingFee = (productList) => {
  if (!productList) {
    return null
  }
  let handlingFee = 0
  const handlingProduct = productList.find((obj) => obj.ProductNo === HANDLING_FEE_PRODUCT_NUMBER)
  if (handlingProduct) {
    handlingFee = handlingProduct.Price
  }
  return handlingFee
}
